import { shape, string } from 'prop-types'

export const medicationPlanType = shape({
  pzn: string,
  name: string,
  startIntakeAt: string,
  endIntakeAt: string,
  additionalInformation: string,
  _id: string,
  updatedAt: string,
})
